import type { SendEventParams } from '@/utils/sendEvent';
import { PixelResponse } from '../../types';
import { BaseTracker } from './BaseTracker';

export interface IRemoveToCartData {
  itemId: string;
  itemName: string;
  value?: number;
  currency?: string;
}
export class RemoveToCartTracker extends BaseTracker {
  public getPayload(data: IRemoveToCartData): SendEventParams {
    this.validateRequiredParams(
      { itemId: data.itemId, itemName: data.itemName },
      ['itemId', 'itemName']
    );
    const { itemId, itemName, value, currency = 'BRL' } = data;
    return {
      visitorId: this.visitorId,
      category: 'ECOMMERCE',
      type: 'REMOVE_TO_CART',
      eventData: {
        itemId,
        itemName,
        value,
        currency,
      },
      config: this.config,
      sessionId: this.sessionId,
      version: this.version,
    };
  }

  public async track({
    itemId,
    itemName,
    value,
    currency = 'BRL',
  }: IRemoveToCartData): Promise<PixelResponse> {
    this.validateRequiredParams({ itemId, itemName }, ['itemId', 'itemName']);
    return this.sendEvent(
      this.getPayload({ itemId, itemName, value, currency })
    );
  }
}
